export const CsImages = {
    userProfile: 'images/profile_avatar_small.jpg'
};

export const CsFaIcons = {
    call: 'fa fa-phone',
    sms: 'fas fa-comment',
    email: 'fa fa-envelope',
    note: 'fa fa-list-alt',
    print: 'fa fa-print',
    calendar: 'fa fa-calendar-alt',
    taskList: 'fa-solid fa-inbox',
    link: 'fa fa-link',
    starSolid: 'fa-solid fa-star',
    starRegular: 'fa-regular fa-star'
};

export const CsIconClasses = {
    squareCheckBox: 'square-check-box'
};
